import { createContext, useContext, type ReactNode, useEffect, useRef, useState } from 'react'
import { useLocation } from '@tanstack/react-router'
import { useIntercomHash } from '@front/model'
import { boot, load, update } from './intercom'

const IntercomReadyContext = createContext(false)

export const useIsIntercomReady = (): boolean => useContext(IntercomReadyContext)

export const IntercomProvider = ({ children }: { children: ReactNode }): ReactNode => {
  const { pathname, searchStr: searchParams } = useLocation()
  const { data } = useIntercomHash('web')
  const booted = useRef(false)
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined' && data && !booted.current) {
      const { jwt } = data
      load()
      boot({
        intercom_user_jwt: jwt,
      })
      booted.current = true
      setIsReady(true)
    }
  }, [data])

  useEffect(() => {
    if (typeof window !== 'undefined') {
      update()
    }
  }, [pathname, searchParams])

  return <IntercomReadyContext.Provider value={isReady}>{children}</IntercomReadyContext.Provider>
}
